function isVisible(el) {
    const style = window.getComputedStyle(el);
    return !(style.display === "none" || style.visibility === "hidden" || style.opacity === "0");
}

window.onResizeEnd = function(callback, delay = 300) {
    let resizeTimer;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(callback, delay);
    });
};

function manageOverflow() {
    function getScrollbarWidth() {
        const scrollDiv = document.createElement("div");
        scrollDiv.style.visibility = "hidden";
        scrollDiv.style.overflow = "scroll";
        scrollDiv.style.position = "absolute";
        scrollDiv.style.top = "-9999px";
        scrollDiv.style.width = "100px";
        scrollDiv.style.height = "100px";

        document.body.appendChild(scrollDiv);
        const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);

        return scrollbarWidth;
    }

    function setScrollbarWidth() {
        document.body.style.overflow = "hidden";
        document.body.style.paddingRight = `${getScrollbarWidth()}px`;
    }

    function clearScrollbarWidth() {
        document.body.removeAttribute("style");
    }

    return { setScrollbarWidth, clearScrollbarWidth };
}
